// Product application
const productApplication = {
  title: 'KELK Product Applications',
  content: 'Can contract various brands of control valve repair and maintenance services. The company has maintenance service bases all over the country, equipped with mobile workshops and supporting maintenance equipment, can provide users with on-site and returned to the factory maintenance and other forms of maintenance services according to actual needs. Kelker has been supplying equipment and maintenance equipment for the oil, petrochemical, metallurgy, power and other industrial control and instrumentation industries for more than 60 years, especially control valves and control equipment with high technical content, as well as customer support services with low torque, which makes it difficult to operate when there is a small amount of acid sludge.'
}

// Solution
const solution = {
  title: 'KELK Engineering Solution',
  content: 'Kelker has been supplying equipment and maintenance equipment for oil and gas, petrochemical, fine chemical, metallurgical and nonferrous metals, industrial gases, energy and environmental protection, electric drive and other industrial control fields and instrumentation industries for more than 60 years, especially control valves and control equipment with high technical content, as well as customer support services.',
}

// Product case
const productCase = {
  tagListAll: [{
    name: 'All',
    id: ''
  }]
}
// 产品应用
const application = {
  tagListAll: [{
    name: '全部',
    id: ''
  }]
}
// 解决方案
const solutionCase = {
  tagListAll: [{
    name: '全部',
    id: ''
  }]
}
// Maintenance case
const maintenanceCase = {
  tagListAll: [{
    name: 'All',
    id: ''
  }]
}

const programDetail = {
  footArticleBtnTxt: 'View Details'
}


export default {
  title: 'Product Program',
  tabs: [
    'Product application',
    'Solution',
    'Product case',
    'Maintenance case',
  ],
  subTitle: 'KELK Product Solutions',
  productApplication,
  solution,
  productCase,
  maintenanceCase,
  programDetail,
  application,
  solutionCase,
  contentTitle1:'area',
  contentTitle2:'customer',
  contentTitle3:'product',
  contentTitle4:'industry',
  contentTitle5:'working condition',
  downloadName:'Data Download'
}


// WEBPACK FOOTER //
// ./src/config/lang/en/productProgramPage.js